module.exports = __webpack_public_path__ + "static/img/img3.84eb7efd.png";